import script from "./summary.vue?vue&type=script&setup=true&lang=ts"
export * from "./summary.vue?vue&type=script&setup=true&lang=ts"

import "./summary.vue?vue&type=style&index=0&id=31ea9c1c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31ea9c1c"]])

export default __exports__